import {
  DownloadException,
} from '@/domain/download/repository/exception/DownloadException'

export class CouldNotCreateApplicationDownloadLinkException extends DownloadException {

}
